import loginbg from "features/ui/svgs/target-bkgd.svg";
import { Auth } from "features/auth";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { authData } from "features/auth/authSlice";

function Login() {
  const { token } = useSelector(authData);

  if (token) {
    return <Navigate to='/' replace />;
  }

  return (
    <>
      <div
        id='login'
        style={{
          background: `url(${loginbg}) no-repeat center center`,
          backgroundColor: "lightslategray",
          backgroundSize: "cover",
        }}
      >
        <Auth />
        {/* comment out the below signup link for now

				<div className='text-center mt-3'>
					<p className='text-white'>
						Don't have an account?&nbsp;&nbsp;
						<Link to='/signup' className='text-white'>
							Sign up
						</Link>
					</p>
				</div>	*/}
      </div>
    </>
  );
}

export default Login;
